import React, { useState } from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { impactStories } from '../data/mockData';
import { ChevronLeft, ChevronRight, Calendar } from 'lucide-react';

const ImpactStoriesSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const itemsPerPage = 4;

  const nextStories = () => {
    setCurrentIndex((prev) => (prev + itemsPerPage) % impactStories.length);
  };

  const prevStories = () => {
    setCurrentIndex((prev) => (prev - itemsPerPage + impactStories.length) % impactStories.length);
  };

  const getVisibleStories = () => {
    const visible = [];
    for (let i = 0; i < itemsPerPage; i++) {
      const index = (currentIndex + i) % impactStories.length;
      visible.push(impactStories[index]);
    }
    return visible;
  };

  return (
    <section id="stories" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Impact Stories
          </h2>
          <div className="w-24 h-1 bg-orange-600 mx-auto"></div>
        </div>

        <div className="relative">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
            {getVisibleStories().map((story) => (
              <Card
                key={story.id}
                className="border-none shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group"
              >
                <div className="relative overflow-hidden h-56">
                  <img
                    src={story.image}
                    alt={story.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
                <CardContent className="p-6">
                  <div className="flex items-center text-sm text-gray-500 mb-3">
                    <Calendar size={16} className="mr-2" />
                    {story.date}
                  </div>
                  <h3 className="text-lg font-bold text-gray-800 mb-3 line-clamp-2 group-hover:text-orange-600 transition-colors duration-200">
                    {story.title}
                  </h3>
                  <p className="text-gray-600 text-sm line-clamp-3">{story.excerpt}</p>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Navigation Buttons */}
          <div className="flex justify-center space-x-4">
            <Button
              onClick={prevStories}
              variant="outline"
              className="border-orange-600 text-orange-600 hover:bg-orange-600 hover:text-white"
            >
              <ChevronLeft className="mr-2" size={20} />
              Previous
            </Button>
            <Button
              onClick={nextStories}
              variant="outline"
              className="border-orange-600 text-orange-600 hover:bg-orange-600 hover:text-white"
            >
              Next
              <ChevronRight className="ml-2" size={20} />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImpactStoriesSection;